import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from "rxjs";
import {SharedDataService} from '@signature-it/ngx-catalogue/services';


@Component({
    selector: 'sidebar-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})

export class SidebarSearchComponent implements OnInit, OnDestroy {

    @Input() key;
    changed: boolean;
    sub: Subscription;

    constructor(
        protected sharedData: SharedDataService
    ) {};

    ngOnInit() {
        this.changed = false;
        // init kw on custom element
        this.sub = this.sharedData.getQueryParams.subscribe(params => {
            if (params) {
                this.key = params.kw;
            }
        })
    }

    onSearchChange() {
        this.changed = true;
    }

    search() {
        if(this.changed) {
            this.changed = false;
            this.sharedData.clickedFilter.next({kw: this.key || ''});
        }

    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

}
